import * as Icons from '@ant-design/icons';
import React from 'react';

export type IconRendererProps = {
  /** 图标名，如 DislikeOutlined */
  icon?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** className */
  className?: string;
  /** 传给 Icon 的其他 props（如 spin） */
  spin?: boolean;
};

// antd 的图标集
export const MyIcon: React.FC<IconRendererProps> = ({
  icon,
  style,
  className,
  spin,
}) => {
  if (!icon) return null;

  const Comp = Icons[icon as keyof typeof Icons] as any;
  if (!Comp) return null;

  return <Comp style={style} className={className} spin={spin} />;
};
